import laborCostNoAccessUrl from './laborCostNoAccess.html';
export default {
  controllerAs: 'ctrl',
  templateUrl: laborCostNoAccessUrl,
};
